import { render, staticRenderFns } from "./CollapsibleContainer.vue?vue&type=template&id=000fe25b&lang=pug"
import script from "./CollapsibleContainer.vue?vue&type=script&lang=js"
export * from "./CollapsibleContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports